export default __webpack_public_path__ + "static/media/clear-sky-night.2af18c24.svg";